<template>
  <v-container>
    <v-row>
      <v-col
        v-for="status in statuses"
        :key="status.uf"
        cols="12"
        sm="6"
        md="4"
        lg="3"
        class="pl-1 pr-1"
      >
        <status-item :status="status" @update="refetch" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed } from "vue";
import { useSefazStatusQuery } from "@/queries/modules/sefaz";
import StatusItem from "@/views/status-sefaz/StatusItem.vue";

const { data, refetch } = useSefazStatusQuery();

const statuses = computed(() => data.value || []);
</script>
